'use client'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { Inventory } from '@/root/shared-types'

export interface UseRouteInfoSectionParams {
  inventory: Inventory
  isLoading: boolean
  preventUndefinedPackageID: boolean
  setHideRoundTripButton: Dispatch<SetStateAction<boolean>>
  routeAttributes?: Record<string, boolean | string>
}

export const useRouteInfoSection = ({
  inventory,
  isLoading,
  preventUndefinedPackageID,
  routeAttributes,
  setHideRoundTripButton,
}: UseRouteInfoSectionParams) => {
  // Shows the loader from the trip-type click until the new inventory arrives
  const [isDirectionChangePending, setIsDirectionChangePending] = useState(false)

  const hideButtonAttribute = routeAttributes?.['HIDE_ROUNDTRIP_BUTTON']
  const showSwapPorts = preventUndefinedPackageID && !hideButtonAttribute

  const handleSetHideRoundTripButton: Dispatch<SetStateAction<boolean>> = (value) => {
    setIsDirectionChangePending(value)
    setHideRoundTripButton(value)
  }

  useEffect(() => {
    setIsDirectionChangePending(false)
  }, [inventory])

  return {
    showSwapPorts,
    handleSetHideRoundTripButton,
    combinedLoading: isLoading || isDirectionChangePending,
  }
}
